import {api} from '@eksab/api';
import {useQuery} from '@eksab/hooks';
import {UseQueryOptions} from '@tanstack/react-query';
import {useCompetitionQuery} from '../hooks';
import {Player} from '../types';
import {lineupCache} from './lineupCache';
import {getIndexFromPosition, State} from './usePlayersReducer';

export function useLineupQuery(
  competitionId: string,
  options?: UseQueryOptions<{
    formation: State['formation'];
    players: State['players'];
    substitutes: State['substitutes'];
    overallCost: number;
  } | null>,
) {
  const {data: competition} = useCompetitionQuery(competitionId, {staleTime: 5 * 60 * 1000});
  return useQuery<{
    formation: State['formation'];
    players: State['players'];
    substitutes: State['substitutes'];
    overallCost: number;
  } | null>(
    ['lineup', competitionId, competition?.joined ? 'participant' : 'guest'],
    () =>
      competition?.joined
        ? api.get(`v2/competitions/${competitionId}/team-setup`).then((res) => {
            if (res.data.data === null) {
              const lineup = lineupCache.getLineup(competitionId);
              return lineup;
            }

            const {formation, players: playersArr} = res.data.data;

            let players: State['players'] = [[], [], [], []];
            let substitutes: State['substitutes'] = [null, null, null, null];
            let overallCost = 0;
            playersArr.forEach((player: Player & {is_substitute: 0 | 1}) => {
              overallCost += player.price;
              if (player.is_substitute) {
                substitutes[getIndexFromPosition(player.position)] = player;
                return;
              }
              players[getIndexFromPosition(player.position)].push(player);
            });
            return {
              players,
              substitutes,
              overallCost,
              formation: formation as Formation,
            };
          })
        : lineupCache.getLineup(competitionId),
    {...options, staleTime: 5 * 60 * 1000},
  );
}
